import React from 'react';
import { Form, Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { GetFFDCustomerByIdService } from '../../../services/common-service';
// import { useGetTaxOrgListQuery } from '../../../hooks/supplier_form_query/getFormMaster';

const { Option } = Select;

export const useGetCustomerByIdQuery = (isShowAllCustomer = false) => {
    const onRequest = async () => {
        const res = await GetFFDCustomerByIdService(/*isShowAllCustomer*/);
        if (res?.status === 200 && res?.data?.statusCode === 200) {
            return res.data?.data;
        } else {
            return [];
        }
    }
    return useQuery({
        queryKey: ['customerById', isShowAllCustomer],
        queryFn: () => onRequest(),
        staleTime: Infinity, // never stale
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    });
};

const FFDCustomerDropDown = ({
    name = 'subClientId',
    label = 'Customer Account',
    placeholder = 'Select Type',
    showAll = false,
}) => {

    const { data, isLoading, refetch, isFetching } = useGetCustomerByIdQuery(showAll);

    // const { data: taxOrgList, isLoading: isTaxOrgLoading } = useGetTaxOrgListQuery();
    return (
        <Form.Item
            name={name}
            label={label}
            labelCol={{ span: 24 }}
        >
            <Select
                placeholder={placeholder}
                loading={isLoading || isFetching}
                allowClear={false}
                showSearch
                filterOption={(input, option) =>
                    String(option?.children).toLowerCase().includes(input.toLowerCase())
                }
                dropdownRender={(menu) => (
                    <>
                        {menu}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                padding: 8,
                                cursor: 'pointer',
                                borderTop: '1px solid #f0f0f0',
                            }}
                            onMouseDown={(e) => e.preventDefault()} // prevent dropdown close
                            onClick={() => refetch()}
                        >
                            🔄 Refresh
                        </div>
                    </>
                )}
            >
                {data?.map((item) => (
                    <Option key={item?.subClientId} value={item?.subClientId} title={`${item?.accountId} - ${item?.accountName}`}>
                        {item?.accountId} - {item?.accountName}
                    </Option>
                ))}
            </Select>

        </Form.Item>
    );
};

export default FFDCustomerDropDown;